
import {
  computed,
  defineComponent,
  onBeforeMount,
  ref,
} from 'vue';
import { useStore } from 'vuex';
import 'vue3-carousel/dist/carousel.css';
import {
  Carousel,
  Slide,
  Pagination,
} from 'vue3-carousel';
import CustomerFeedback from '@/interfaces/CustomerFeedback';
import Observer from '@/components/Observer.vue';

export default defineComponent({
  components: {
    Observer,
    Carousel,
    Slide,
    Pagination,
  },

  props: {
    categories: {
      type: String,
      required: false,
      default: () => 'all',
    },
    customerFeedbacks: {
      type: Array,
      required: false,
    },
  },

  setup(props) {
    const store = useStore();

    const categories = computed(() => {
      if (props.categories && props.categories.trim() !== '') {
        return props.categories.split(',');
      }

      return ['all'];
    });

    const items = computed<CustomerFeedback[]>(() => {
      if (props.customerFeedbacks) {
        return props.customerFeedbacks;
      }

      return store.getters['customerFeedbacks/get'](categories.value);
    });

    const observed = ref(false);

    onBeforeMount(() => {
      if (!props.customerFeedbacks) {
        store.dispatch('customerFeedbacks/get', categories.value);
      }
    });

    return {
      items,
      observed,
    };
  },
});
